import { Currency } from "src/api-service";

// **************************************************************************
// CURRENCY STATE
// **************************************************************************
export interface CurrencyState {
    currency: Currency | null;
    currencies: Currency[];
    currenciesLoading: boolean;
}

export const initialCurrencyState: CurrencyState = {
    currency: null,
    currencies: [],
    currenciesLoading: false,
};
